/*
  Chesapeake Hatchery: Shop by Hatch Date (draft).
  Read-only use of product.metafields.sidekick.weekly_inventory.
  Adds the shared cart property _shipping_week (MM/DD/YYYY) used by assets/chesapeake-hatch-date.js.
  The cart's hatch-date check remains the final validation before checkout.
*/
(function () {
  'use strict';
  if (window.ChShopDate) return;

  var KEY = 'chShopHatchDate';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var listeners = [];

  function pad(n) { return String(n).padStart(2, '0'); }
  function todayIso() { var d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function isIso(v) { return typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v); }
  function parse(iso) { var p = iso.split('-').map(Number); return new Date(Date.UTC(p[0], p[1] - 1, p[2])); }
  function isTuesday(iso) { return isIso(iso) && parse(iso).getUTCDay() === 2; }
  function addDays(iso, n) { var d = parse(iso); d.setUTCDate(d.getUTCDate() + n); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function label(iso, opts) {
    if (!isIso(iso)) return '';
    var d = parse(iso);
    var s = MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate();
    if (!opts || opts.weekday !== false) s = DAYS[d.getUTCDay()] + ', ' + s;
    if (opts && opts.year) s += ', ' + d.getUTCFullYear();
    return s;
  }
  function toStored(iso) { return iso.slice(5, 7) + '/' + iso.slice(8, 10) + '/' + iso.slice(0, 4); }
  function fromStored(v) {
    if (typeof v !== 'string' || !/^\d{2}\/\d{2}\/\d{4}$/.test(v)) return '';
    var iso = v.slice(6, 10) + '-' + v.slice(0, 2) + '-' + v.slice(3, 5);
    return isTuesday(iso) ? iso : '';
  }
  function valid(iso) { return isTuesday(iso) && iso >= todayIso(); }

  function get() {
    try {
      var iso = localStorage.getItem(KEY) || '';
      if (valid(iso)) return iso;
      if (iso) localStorage.removeItem(KEY);
    } catch (_) {}
    return '';
  }
  function set(iso, source) {
    var next = valid(iso) ? iso : '';
    var prev = get();
    try { if (next) localStorage.setItem(KEY, next); else localStorage.removeItem(KEY); } catch (_) {}
    if (prev !== next) listeners.forEach(function (fn) { try { fn(next, source || ''); } catch (e) { console.error(e); } });
    return next;
  }
  function onChange(fn) { listeners.push(fn); }

  /* Inventory helpers (same pool math as the cart check). */
  function slot(product, sex, iso) {
    var week = product && product.inventory ? product.inventory[iso] : null;
    if (!week || typeof week !== 'object') return null;
    var s = sex === 'straight_run' ? (week.straight_run || week.sr) : week[sex];
    if (!s || typeof s !== 'object') return null;
    var cap = Number(s.capacity), res = Number(s.reserved);
    if (!Number.isSafeInteger(cap) || !Number.isSafeInteger(res) || cap < 0 || res < 0) return null;
    return Math.max(0, cap - res);
  }
  function variantLeft(product, variant, iso) {
    if (!variant || !variant.available || ['female', 'male', 'straight_run'].indexOf(variant.sex) === -1) return 0;
    return slot(product, variant.sex, iso) || 0;
  }
  function productLeft(product, iso) {
    return (product.variants || []).reduce(function (sum, v) { return sum + variantLeft(product, v, iso); }, 0);
  }
  function weeks(products) {
    var t = todayIso(), set = {};
    products.forEach(function (p) {
      Object.keys(p.inventory || {}).forEach(function (iso) { if (isTuesday(iso) && iso >= t) set[iso] = true; });
    });
    return Object.keys(set).sort();
  }

  /* Cart helpers */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartJs() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }
  var DATED_TYPES = ['Day-Old Chicks', 'Pullets', 'Hatching Eggs'];
  function cartDate(cart) {
    var values = (cart.items || []).filter(function (i) { return DATED_TYPES.indexOf(i.product_type) !== -1; })
      .map(function (i) { return i.properties && i.properties._shipping_week; }).filter(Boolean);
    var uniq = values.filter(function (v, i) { return values.indexOf(v) === i; });
    return { iso: uniq.length === 1 ? fromStored(uniq[0]) : '', mixed: uniq.length > 1, count: values.length };
  }
  function refreshCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return Promise.resolve();
    return fetch(root + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data['cart-icon-bubble'] || '', 'text/html');
        var inner = html.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }).catch(function () {});
  }

  function readJson(el) {
    try { return JSON.parse(el.textContent); } catch (e) { console.error('Shop by hatch date: data could not be read', e); return null; }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- Site-wide date bar ---------- */
  function mountBar(bar) {
    var dateEl = bar.querySelector('[data-ch-sbd-bar-date]');
    var clearBtn = bar.querySelector('[data-ch-sbd-bar-clear]');
    function render(iso) {
      bar.hidden = !iso;
      if (iso) dateEl.textContent = label(iso, { year: false });
    }
    clearBtn && clearBtn.addEventListener('click', function () { set('', 'bar'); });
    onChange(render);
    render(get());
  }

  /* ---------- Collection: shop by hatch date ---------- */
  function mountCollection(root) {
    var data = readJson(root.querySelector('[data-ch-sbd-data]'));
    if (!data) return;
    var products = (data.products || []).filter(Boolean);
    var cfg = data.settings || {};
    var chips = root.querySelector('[data-ch-sbd-chips]');
    var grid = root.querySelector('[data-ch-sbd-grid]');
    var summary = root.querySelector('[data-ch-sbd-summary]');
    var cartNote = root.querySelector('[data-ch-sbd-cart-note]');
    var empty = root.querySelector('[data-ch-sbd-empty]');
    var mainGrid = document.querySelector(cfg.mainGridSelector || '[id$="__main-product-grid"]');
    var allWeeks = weeks(products);
    var openWeeks = allWeeks.filter(function (iso) { return products.some(function (p) { return productLeft(p, iso) > 0; }); });
    var cartInfo = { iso: '', mixed: false, count: 0 };

    if (!openWeeks.length) {
      empty.hidden = false;
      chips.hidden = true;
      if (mainGrid) mainGrid.hidden = false;
      return;
    }

    function chip(iso, text, sub) {
      var b = el('button', 'ch-sbd__chip');
      b.type = 'button';
      b.dataset.iso = iso;
      b.setAttribute('role', 'radio');
      b.appendChild(el('span', 'ch-sbd__chip-main', text));
      if (sub) b.appendChild(el('span', 'ch-sbd__chip-sub', sub));
      b.addEventListener('click', function () { set(iso, 'collection'); });
      return b;
    }
    chips.replaceChildren();
    chips.appendChild(chip('', cfg.allLabel || 'All breeds', cfg.allSub || 'Any date'));
    openWeeks.forEach(function (iso) {
      var n = products.filter(function (p) { return productLeft(p, iso) > 0; }).length;
      chips.appendChild(chip(iso, label(iso), n + ' ' + (cfg.unit || 'breed') + (n === 1 ? '' : 's')));
    });

    function renderCartNote(iso) {
      if (!cartNote) return;
      if (iso && cartInfo.count && (cartInfo.mixed || (cartInfo.iso && cartInfo.iso !== iso))) {
        cartNote.textContent = (cfg.cartNote || 'Your cart has chicks for a different date. Every order hatches on one shared date, so you\'ll confirm one date in the cart.')
          + (cartInfo.iso ? ' (Cart: ' + label(cartInfo.iso) + '.)' : '');
        cartNote.hidden = false;
      } else {
        cartNote.hidden = true;
      }
    }

    function card(p, iso) {
      var c = el('article', 'ch-sbd__card');
      var media = el('a', 'ch-sbd__media');
      media.href = p.url + '?hatch=' + iso;
      if (p.image) {
        var img = el('img');
        img.src = p.image; img.alt = p.imageAlt || p.label; img.loading = 'lazy'; img.width = 600; img.height = 600;
        media.appendChild(img);
      }
      c.appendChild(media);
      var body = el('div', 'ch-sbd__body');
      var h = el('h3', 'ch-sbd__title');
      var link = el('a', null, p.label); link.href = p.url + '?hatch=' + iso;
      h.appendChild(link);
      body.appendChild(h);

      var options = el('div', 'ch-sbd__options');
      options.setAttribute('role', 'radiogroup');
      options.setAttribute('aria-label', 'Choose type for ' + p.label);
      var chosen = null, firstOpen = null;
      var name = 'ch-sbd-' + p.id + '-' + iso;
      p.variants.forEach(function (v) {
        var left = variantLeft(p, v, iso);
        var id = name + '-' + v.id;
        var wrap = el('label', 'ch-sbd__opt' + (left > 0 ? '' : ' is-out'));
        wrap.setAttribute('for', id);
        var input = el('input');
        input.type = 'radio'; input.name = name; input.id = id; input.value = v.id; input.disabled = left <= 0;
        wrap.appendChild(input);
        var t = el('span', 'ch-sbd__opt-label', v.label.replace(/\s*\((Female|Male|Unsexed)\)/i, ''));
        var meta = el('span', 'ch-sbd__opt-meta');
        meta.textContent = left > 0
          ? v.price + ' · ' + (left <= (cfg.lowStock || 25) ? 'Only ' + left + ' left' : left + ' available')
          : (cfg.notThisWeek || 'Not this week');
        wrap.appendChild(t); wrap.appendChild(meta);
        input.addEventListener('change', function () { chosen = { v: v, left: left }; syncQty(); });
        if (left > 0 && !firstOpen) firstOpen = { v: v, left: left, input: input };
        options.appendChild(wrap);
      });
      body.appendChild(options);

      var row = el('div', 'ch-sbd__buy');
      var qtyWrap = el('div', 'ch-sbd__qty');
      var minus = el('button', 'ch-sbd__step', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity');
      var qty = el('input'); qty.type = 'number'; qty.min = 1; qty.value = 1; qty.inputMode = 'numeric'; qty.setAttribute('aria-label', 'Quantity of ' + p.label);
      var plus = el('button', 'ch-sbd__step', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity');
      qtyWrap.appendChild(minus); qtyWrap.appendChild(qty); qtyWrap.appendChild(plus);
      var add = el('button', 'ch-sbd__add', cfg.addLabel || 'Add to cart'); add.type = 'button';
      row.appendChild(qtyWrap); row.appendChild(add);
      if (cfg.closed) {
        var closedNote = el('p', 'ch-sbd__closed', (cfg.closedText || 'Ordering isn\'t open yet.') + ' ');
        var wl = el('a', 'ch-sbd__view', cfg.closedLink || 'Join the waitlist'); wl.href = '#waitlist';
        closedNote.appendChild(wl);
        body.appendChild(closedNote);
      } else {
        body.appendChild(row);
      }
      var status = el('p', 'ch-sbd__status'); status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      body.appendChild(status);
      c.appendChild(body);

      function syncQty() {
        var max = chosen ? chosen.left : 1;
        qty.max = max;
        var n = parseInt(qty.value, 10) || 1;
        qty.value = Math.min(Math.max(1, n), max);
      }
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); syncQty(); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 0) + 1; syncQty(); });
      qty.addEventListener('change', syncQty);
      if (firstOpen) { firstOpen.input.checked = true; chosen = { v: firstOpen.v, left: firstOpen.left }; syncQty(); }

      add.addEventListener('click', function () {
        if (cfg.closed) return;
        if (!chosen) { status.textContent = 'Choose an option first.'; return; }
        syncQty();
        var n = parseInt(qty.value, 10) || 1;
        add.disabled = true; add.textContent = cfg.addingLabel || 'Adding…'; status.textContent = '';
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(chosen.v.id), quantity: n, properties: { _shipping_week: toStored(iso) } }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart.');
            status.replaceChildren();
            status.appendChild(document.createTextNode('Added ' + n + ' for ' + label(iso) + '. '));
            var view = el('a', 'ch-sbd__view', cfg.viewCartLabel || 'View cart'); view.href = (window.routes && window.routes.cart_url) || '/cart';
            status.appendChild(view);
            add.textContent = cfg.addedLabel || 'Added';
            cartInfo = { iso: cartInfo.mixed ? '' : (cartInfo.iso && cartInfo.iso !== iso ? '' : iso), mixed: cartInfo.mixed || (cartInfo.iso && cartInfo.iso !== iso), count: cartInfo.count + 1 };
            renderCartNote(iso);
            refreshCartBubble();
            setTimeout(function () { add.textContent = cfg.addLabel || 'Add to cart'; add.disabled = false; }, 1600);
          })
          .catch(function (e) { status.textContent = e.message; add.textContent = cfg.addLabel || 'Add to cart'; add.disabled = false; });
      });
      return c;
    }

    function render(iso) {
      if (iso && openWeeks.indexOf(iso) === -1) iso = '';
      chips.querySelectorAll('.ch-sbd__chip').forEach(function (b) {
        var on = b.dataset.iso === iso;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var active = chips.querySelector('.is-active');
      if (active && active.scrollIntoView && iso) active.scrollIntoView({ block: 'nearest', inline: 'center' });
      grid.replaceChildren();
      if (!iso) {
        grid.hidden = true; summary.hidden = true;
        if (mainGrid) mainGrid.hidden = false;
        renderCartNote('');
        return;
      }
      var list = products.filter(function (p) { return productLeft(p, iso) > 0; });
      var pickup = addDays(iso, 1);
      summary.textContent = cfg.mode === 'eggs'
        ? list.length + ' ' + (cfg.unit || 'breed') + (list.length === 1 ? '' : 's') + ' shipping the week of ' + label(iso)
        : list.length + ' ' + (cfg.unit || 'breed') + (list.length === 1 ? '' : 's') + ' hatching ' + label(iso) +
          (cfg.showPickup ? ' · Ships ' + label(iso, { weekday: false }) + ' or local pickup Wed, ' + label(pickup, { weekday: false }) : '');
      summary.hidden = false;
      list.forEach(function (p) { grid.appendChild(card(p, iso)); });
      grid.hidden = false;
      if (mainGrid) mainGrid.hidden = true;
      renderCartNote(iso);
    }

    onChange(function (iso) { render(iso); });
    var start = get();
    render(start);
    cartJs().then(function (cart) {
      cartInfo = cartDate(cart);
      if (!get() && cartInfo.iso && openWeeks.indexOf(cartInfo.iso) !== -1) set(cartInfo.iso, 'cart');
      else renderCartNote(get());
    }).catch(function () {});
  }

  /* ---------- Product page notice + hidden date property ---------- */
  function mountProduct(box) {
    var p = readJson(box.querySelector('[data-ch-sbd-data]'));
    if (!p) return;
    var cfg = { lowStock: Number(box.dataset.lowStock) || 25, soon: box.dataset.soon || '' };
    var noun = p.type === 'Hatching Eggs' ? 'ship week' : 'hatch date';
    var form = (box.dataset.formId && document.getElementById(box.dataset.formId)) ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      Array.prototype.find.call(document.querySelectorAll('form[action*="/cart/add"][id^="product-form-"]'), function (f) { return f.id.indexOf('installment') === -1; });
    var msg = box.querySelector('[data-ch-sbd-msg]');
    var picker = box.querySelector('[data-ch-sbd-picker]');
    var select = box.querySelector('select');
    var open = weeks([p]).filter(function (iso) { return productLeft(p, iso) > 0; });
    var cartNoteEl = box.querySelector('[data-ch-sbd-cart-note]');
    var compare = box.querySelector('[data-ch-sbd-compare]');
    var table = box.querySelector('[data-ch-sbd-table]');
    var moreBtn = box.querySelector('[data-ch-sbd-more]');
    var SHOW_ROWS = 6;
    var showAll = false;
    var cartInfo = { iso: '', mixed: false, count: 0 };
    function shortLabel(v) { return v.label.replace(/\s*\((Female|Male|Unsexed)\)/i, ''); }

    function renderCartNote() {
      if (!cartNoteEl) return;
      var iso = get();
      cartNoteEl.replaceChildren();
      if (!cartInfo.count || !open.length) { cartNoteEl.hidden = true; return; }
      if (cartInfo.mixed) {
        cartNoteEl.appendChild(document.createTextNode('Your cart already has items on more than one date. Every order ships on one shared date, so you\'ll pick one date in the cart before checkout.'));
      } else if (cartInfo.iso && iso && cartInfo.iso !== iso) {
        cartNoteEl.appendChild(document.createTextNode('Your cart already has items for ' + label(cartInfo.iso) + '. Every order ships on one shared date, so adding this for ' + label(iso) + ' means choosing one date in the cart. '));
        var use = el('button', 'ch-sbd-product__use', 'Use ' + label(cartInfo.iso) + ' instead');
        use.type = 'button';
        use.addEventListener('click', function () { set(cartInfo.iso, 'product'); render(); });
        cartNoteEl.appendChild(use);
      } else {
        cartNoteEl.hidden = true; return;
      }
      cartNoteEl.hidden = false;
    }
    function loadCart() {
      return cartJs().then(function (cart) { cartInfo = cartDate(cart); renderCartNote(); renderTable(); }).catch(function () {});
    }

    function renderTable() {
      if (!table || !compare) return;
      if (!open.length) { compare.hidden = true; return; }
      var iso = get();
      var variant = current();
      var single = p.variants.length === 1;
      table.replaceChildren();
      var thead = el('thead'), hr = el('tr');
      var th0 = el('th', null, noun.charAt(0).toUpperCase() + noun.slice(1)); th0.scope = 'col'; hr.appendChild(th0);
      p.variants.forEach(function (v) {
        var th = el('th', v === variant && !single ? 'is-current' : null, single ? 'Available' : shortLabel(v)); th.scope = 'col'; hr.appendChild(th);
      });
      thead.appendChild(hr); table.appendChild(thead);
      var tbody = el('tbody');
      var rows = showAll ? open : open.slice(0, SHOW_ROWS);
      if (!showAll && iso && open.indexOf(iso) >= SHOW_ROWS) rows = rows.concat([iso]);
      rows.forEach(function (w) {
        var tr = el('tr', w === iso ? 'is-selected' : null);
        var td0 = el('th'); td0.scope = 'row';
        var b = el('button', 'ch-sbd-product__pick', label(w));
        b.type = 'button';
        b.setAttribute('aria-pressed', w === iso ? 'true' : 'false');
        b.addEventListener('click', function () { set(w, 'product'); render(); });
        td0.appendChild(b);
        if (cartInfo.iso === w) td0.appendChild(el('span', 'ch-sbd-product__in-cart', 'In your cart'));
        tr.appendChild(td0);
        p.variants.forEach(function (v) {
          var n = variantLeft(p, v, w);
          var td = el('td', (v === variant && !single ? 'is-current ' : '') + (n > 0 ? '' : 'is-out'), n > 0 ? String(n) : '—');
          if (n <= 0) td.setAttribute('aria-label', 'none left');
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      if (moreBtn) {
        moreBtn.hidden = open.length <= SHOW_ROWS;
        moreBtn.textContent = showAll ? 'Show fewer weeks' : 'Show all ' + open.length + ' weeks';
      }
      compare.hidden = false;
    }
    if (moreBtn) moreBtn.addEventListener('click', function () { showAll = !showAll; renderTable(); });

    function plural(v) {
      var w = v.toLowerCase();
      if (/straight run|eggs$|chicks$|s$/.test(w)) return w;
      return w + 's';
    }
    function current() {
      var idInput = form && form.querySelector('[name="id"]');
      var id = idInput ? String(idInput.value) : '';
      return p.variants.find(function (v) { return String(v.id) === id; }) || p.variants[0];
    }
    function ensureHidden(iso, variant) {
      if (!form) return;
      var h = form.querySelector('input[name="properties[_shipping_week]"]');
      var ok = iso && variantLeft(p, variant, iso) > 0;
      if (ok) {
        if (!h) { h = el('input'); h.type = 'hidden'; h.name = 'properties[_shipping_week]'; form.appendChild(h); }
        h.value = toStored(iso);
      } else if (h) {
        h.remove();
      }
    }
    function fillSelect(variant) {
      var iso = get();
      select.replaceChildren(new Option('Choose a ' + noun, ''));
      open.forEach(function (w) {
        var left = variantLeft(p, variant, w);
        var o = new Option(label(w) + (left > 0 ? (left <= (cfg.lowStock || 25) ? ' · Only ' + left + ' left' : ' · ' + left + ' available') : ' · Not this week'), w);
        o.disabled = left <= 0;
        select.add(o);
      });
      select.value = iso && variantLeft(p, variant, iso) > 0 ? iso : '';
    }
    function render() {
      var variant = current();
      var iso = get();
      ensureHidden(iso, variant);
      if (!open.length) {
        box.dataset.state = 'soon';
        msg.textContent = cfg.soon || ('2027 ' + noun + 's for this breed will be posted soon.');
        picker.hidden = true;
        return;
      }
      picker.hidden = false;
      fillSelect(variant);
      function lcType(t) { return t.replace(/\b(straight run|females?|males?|pullets?|cockerels?|roosters?|hens?|unsexed|bundles?)\b/gi, function (m) { return m.toLowerCase(); }); }
      var vl = variant.label.replace(/\s*\((Female|Male|Unsexed)\)/i, '');
      if (iso) {
        var left = variantLeft(p, variant, iso);
        if (left > 0) {
          box.dataset.state = 'ok';
          msg.textContent = label(iso) + ': ' + (left <= (cfg.lowStock || 25) ? 'only ' + left : left) + ' ' + plural(vl) + ' left.' + (box.dataset.closed === 'true' ? ' Ordering isn\'t open yet.' : ' They\'ll go in your cart with this ' + noun + '.');
        } else {
          var next = open.find(function (w) { return w > iso && variantLeft(p, variant, w) > 0; }) ||
                     open.find(function (w) { return variantLeft(p, variant, w) > 0; });
          var others = p.variants.filter(function (v) { return v !== variant && variantLeft(p, v, iso) > 0; })
            .map(function (v) { return lcType(v.label.replace(/\s*\((Female|Male|Unsexed)\)/i, '')); });
          box.dataset.state = 'warn';
          msg.textContent = vl + ' isn\'t available for ' + label(iso) + '.' +
            (others.length ? ' Available that week: ' + others.join(', ') + '.' : '') +
            (next ? ' Next ' + lcType(vl) + ' ' + noun + ': ' + label(next) + '.' : '');
        }
      } else {
        var first = open.find(function (w) { return variantLeft(p, variant, w) > 0; });
        box.dataset.state = 'info';
        msg.textContent = first ? 'Next ' + noun + ' for ' + lcType(vl) + ': ' + label(first) + '. Pick a date to see how many are left.' :
          vl + ' isn\'t open on any upcoming ' + noun + ' yet.';
      }
    }
    var baseRender = render;
    render = function () { baseRender(); renderCartNote(); renderTable(); };
    select.addEventListener('change', function () { set(select.value, 'product'); render(); });
    onChange(render);
    loadCart();
    document.addEventListener('submit', function (e) { if (e.target === form) setTimeout(loadCart, 1500); });
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) { try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(loadCart, 300); }); } catch (_) {} }
    if (form) {
      form.addEventListener('change', function () { setTimeout(render, 0); });
      document.addEventListener('submit', function (e) { if (e.target === form) ensureHidden(get(), current()); }, true);
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios')) setTimeout(render, 60); });
    render();
  }

  /* ---------- Cart page: remember the date the shopper picks ---------- */
  function mountCartSync() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'cart-shipping-week-select') {
        var iso = fromStored(e.target.value);
        if (iso) set(iso, 'cart');
      }
    });
  }

  /* ---------- Boot ---------- */
  function readParam() {
    try {
      var v = new URL(location.href).searchParams.get('hatch');
      if (v && valid(v)) set(v, 'url');
    } catch (_) {}
  }
  function boot() {
    readParam();
    document.querySelectorAll('[data-ch-sbd-bar]').forEach(mountBar);
    document.querySelectorAll('[data-ch-sbd-collection]').forEach(mountCollection);
    document.querySelectorAll('[data-ch-sbd-product]').forEach(mountProduct);
    mountCartSync();
    if (!get() && document.querySelector('[data-ch-sbd-bar]') && !document.querySelector('[data-ch-sbd-collection]')) {
      cartJs().then(function (cart) { var c = cartDate(cart); if (c.iso && !get()) set(c.iso, 'cart'); }).catch(function () {});
    }
  }

  window.ChShopDate = {
    get: get, set: set, onChange: onChange, label: label, toStored: toStored, fromStored: fromStored,
    variantLeft: variantLeft, productLeft: productLeft, weeks: weeks, addDays: addDays, todayIso: todayIso
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
